import React, { Component, Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import { injectIntl } from 'react-intl';
var classNames = require('classnames');

import API from '../../api/index';
import SortableTree from '@nosferatu500/react-sortable-tree';
import '@nosferatu500/react-sortable-tree/style.css';
import { NotificationManager } from "Components/ReactNotifications";

import {
    logoutUser
} from "Redux/actions";
import { connect } from "react-redux";

import {
    Row,
    Progress,
    Card,
    CardBody,
    CardTitle,
    Button
} from "reactstrap";

import { Colxx } from "Components/CustomBootstrap";


class ProductTreeManager extends Component {
    constructor(props) {
        super(props);

        this.state = {
            saveClicked: false,
            saveIndex: -1,
            saveQueue: [],
            productsDataTree: [],
            treeData: [
                { title: 'Chicken', children: [{ title: 'Egg' }] },
                { title: 'Fish', children: [{ title: 'fingerline' }] },
            ],
            isLoading: true
        };

        this.loadData = this.loadData.bind(this);
        this.saveTreeData = this.saveTreeData.bind(this);
        this.updateSize = this.updateSize.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.startSaveProgress = this.startSaveProgress.bind(this);
        this.saveProgressNext = this.saveProgressNext.bind(this);
        this.loadData();
    }
    startSaveProgress() {
        this.setState({ saveIndex: -1 });
        this.setState({ saveClicked: true });

        this.saveProgressNext();
    }
    saveProgressNext() {
        if (this.state.saveIndex < this.state.saveQueue.length) {

            this.setState({ saveIndex: this.state.saveIndex + 1 });

            API.system.saveItemWeight(this.state.saveQueue[this.state.saveIndex])
                .then(data => {
                    (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
                    if (data.DONE == true) {
                        this.saveProgressNext();
                    } else {
                        this.setState({ saveClicked: false });
                        NotificationManager.error(
                            "لطفا دوباره تلاش نمایید",
                            "مشکل در ذخیره قیمت ",
                            3000, null, null, "filled");
                    }
                })
                .catch(error => {
                    this.setState({ saveClicked: false });
                    NotificationManager.error(
                        "لطفا دوباره تلاش نمایید",
                        "مشکل در ذخیره قیمت ",
                        3000, null, null, "filled");
                });
        } else {
            this.setState({ saveClicked: false });
            NotificationManager.primary(
                "درخت نمایش محصولات در ثبت سفارش با ساختار جدید ثبت شد"
                , "درخت ذخیره شد"
                , 3000, null, null, "filled");
        }
    }
    loadData(key) {
        API.order.new.productsTree()
            .then(data => {
                (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
                this.setState({
                    treeData: data,
                    isLoading: false,
                });
                this.updateSize();

            })
            .catch(error => { });
    }
    componentDidMount() {
        window.addEventListener('resize', this.updateSize);
        this.updateSize();
    }
    updateSize() {
        if (!this.state.isLoading && document.querySelector(".auto-win-height") !== null) {
            window.autoWinWidth = document.querySelector(".auto-win-height").offsetWidth;
            document.querySelector(".auto-win-height").style.overflow = "hidden";
            document.querySelector(".auto-win-height").style.width = document.querySelector("#side-card").offsetWidth + "px";
            document.querySelector(".auto-win-height").style.height = (window.innerHeight - document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight - 80) + "px";
            document.querySelector(".auto-win-height").style.position = "fixed";
            document.querySelector(".auto-win-height").style.top = document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight + 40 + "px";
            document.querySelector(".auto-win-height-scroll").style.height = (window.innerHeight - document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight - 200) + "px";
            document.querySelector(".auto-win-height-scroll").style.overflow = "scroll";
        }
    }
    saveTreeData() {
        API.system.saveProductsTree(this.state.treeData)
            .then(data => {
                (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
                this.setState({ saveQueue: data.saveQueue });
                this.startSaveProgress();
            })
            .catch(error => { });
    }
    render() {
        return (
            this.state.isLoading ?
                <div className="loading"></div>
                :
                <Fragment>
                    <Row className="mb-4">

                        <Colxx xxs="6">
                            <Card className="timeline-card auto-win-height" style={{ "backgroundColor": "transparent" }}>
                                <CardBody style={{ "backgroundColor": "rgba(0,0,0,0.03)" }}>
                                    <CardTitle>
                                        <div className={"simple-icon-share headingicon"} /> مدیریت درخت نمایش محصولات در ثبت سفارش
                                    </CardTitle>

                                    <div className="auto-win-height-scroll">
                                        <SortableTree
                                            rowDirection="rtl"
                                            treeData={this.state.treeData}
                                            onChange={treeData => this.setState({ treeData })}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </Colxx>
                        <Colxx xxs="6">
                            <Card id={"side-card"}>
                                <CardBody>
                                    <CardTitle>
                                        <div className={"iconsminds-save headingicon"} />
                                        ذخیره تغییرات درخت
                                        &nbsp; {this.state.saveIndex > -1 ?
                                            <label>[ &nbsp;
                                                {this.state.saveIndex + 1} / {this.state.saveQueue.length}  &nbsp;]
                                            </label>
                                            : <span />}
                                        <Button color="primary" disabled={this.state.saveClicked} className="default mb-2" style={{ float: "left" }} onClick={() => { confirm('آیا از ذخیره تغییرات درخت مطمئن هستید؟') ? this.saveTreeData() : false; }} >
                                            ذخیره تغییرات درخت
                                        </Button>
                                    </CardTitle>
                                    <Progress value={(this.state.saveIndex / this.state.saveQueue.length) * 100} />
                                </CardBody>
                            </Card>
                            <br />

                        </Colxx>
                    </Row>
                </Fragment>
        );
    }
}


const mapStateToProps = ({ menu, settings }) => {
    return { logoutUser };
  };
  export default injectIntl(connect(
    mapStateToProps,
    { logoutUser }
  )(ProductTreeManager));
// export default injectIntl(ProductTreeManager);
